<template>
	<div class="content">
		<headerTop></headerTop>
		<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(img)+')'}"></div>
		<!-- 服务案例 -->
		<div class="center page-content flexbetween" :style="{animation:animation}">
			<div class="left">
				<div class="leftD">
					<div class="leftD_child" v-for="(item,index) in techList" @click="todetail(item.id)">{{item.title}}</div>
				</div>
			</div>
			<div class="right">
				<div class="anliList flexleft">
					<div class="alchild" v-for="(item,index) in list" :key="index" @click="todetails(item.id)">
						<div class="img">
							<img :src="$index.addurl(item.image)" alt="">
						</div>
						<div class="title">{{item.title}}</div>
						<div class="time">{{item.createtime}}</div>
					</div>
				</div>
				<div class="page">
					<el-pagination
					:hide-on-single-page="value"
					:current-page="currentPage"
					  :page-size="9"
					  @current-change = "addPage"
					  layout="prev, pager, next"
					  :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default{
		components: {
			headerTop
		},
		data(){
			return {
				value:true,  //分页只有一页时隐藏分页
				currentPage:1, //分页当前页数
				list:[],
				total:0,
				img:'',
				animation:'',
				techList:[],
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.getdata();
			this.getqylist();
		},
		methods:{
			todetail(id){
				if(id == 1){
					this.$router.push({name:'fwTixi',query:{id:id}})
				}else if(id == 2){
					this.$router.push({name:'cxPingtai',query:{id:id}})
				}else if(id == 3){
					this.$router.push({name:'jrfuCs',query:{id:id}})
				}else if(id == 4){
					this.$router.push({name:'fwAnlis',query:{id:id}})
				}
			},
			getqylist(){
				let _this = this;
				_this.$api.user.enterpriseServicesList().then(res => {
					if(res.code == 1){
						_this.techList = res.data;
					}
				})
			},
			todetails(id){
				this.$router.push({name:'hdAldetail',params:{id:id}});
			},
			date(timer) {
				var date = new Date(timer); //当前时间
				var year = date.getFullYear() //返回指定日期的年份
				var month = repair(date.getMonth() + 1); //月
				var day = repair(date.getDate()); //日
				var curTime = year + "-" + month + "-" + day

				function repair(i) {
				  if (i >= 0 && i <= 9) {
					return "0" + i;
				  } else {
					return i;
				  }
				}
				return curTime
			  },
			getdata(page){
				let _this = this;
				_this.$api.user.activityCasesList({
					page:page||1,
				}).then(res => {
					if(res.code == 1){
						_this.img = res.data.background_img;
						res.data.list.data.forEach(item => {
							item.createtime = _this.date(item.createtime*1000);
						})
						_this.total = res.data.list.total;
						_this.list = res.data.list.data;
					}
				})
			},
			addPage(e){
				this.currentPage = e;
				this.getdata(e);
			},
		},
		
	}
</script>
<style scoped>
	.content{
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
		/* overflow: hidden; */
	}
</style>
<style scoped lang="scss">
	.left{
		align-self: flex-start;
		position: sticky;
		top: 100px;
		.leftD{
			background-color: #fff;
			border-radius: 20px;
			padding: 14px 20px 6px;
			width: 8vw;
			align-self: flex-start;
			z-index: 100;
			background-color: rgba(207, 232, 252, 0.5);
			margin-right: 20px;
			.leftD_child{
				margin: 20px 0;
				padding-bottom: 10px;
				font-size: 16px;
				text-align: center;
				color: #333;
				border-bottom: 1px solid #fff;
			}
			.leftD_child:last-child{
				border: none;
			}
			.leftD_child:hover{
				cursor: pointer;
				color: #1452DC;
				animation: changeTab .2s linear forwards;
			}
		}
	}
	.right{
		flex-grow: 1;
	}
	.swiperImg{
		max-width: 1920px;
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 220px 0;
		.lTitle{
			margin-left: 4vw;
			font-size: 30px;
			letter-spacing: 4px;
			color: #fff;
		}
		.bTitle{
			margin-left: 4vw;
			color: #fff;
			font-size: 58px;
			letter-spacing: 4px;
			font-weight: bold;
		}
		.sTitle{
			margin-left: 4vw;
			letter-spacing: 2px;
			font-size: 14px;
			color: #fff;
		}
	}
	.center{
		min-height: 300px;
		margin: 0 auto 100px;
		background-color: #fff;
		// padding: 70px 120px;
		padding: 80px 120px 60px 60px;
		border-radius: 30px;
		position: relative;
		top: -80px;
		.page{
			margin: auto;
			display: flex;
			justify-content: center;
		}
		.anliList{
			flex-wrap: wrap;
			.alchild{
				width: 30.5%;
				cursor: pointer;
				margin: 0 10px 30px;
				.img{
					width: 100%;
					height: 180px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.title{
					font-size: 18px;
					color: #333;
					font-weight: bold;
					margin: 10px 0;
				}
				.time{
					font-size: 12px;
					color: #aaa;
				}
			}
		}
		.prosss{
			margin: auto;
			.list{
				position: relative;
				.childs{
					width: 20px;
					height:20px;
					margin: 30px ;
					border: 4px solid #1452DC;
					border-radius: 50%;
					position: relative;
					.line{
						position: absolute;
						bottom: -64px;
						left: 5px;
						background-color: #1452DC;
						width: 2px;
						height: 64px;
					}
				}
			}
			.list:last-child{
				.childs{
					.line{
						display: none;
					}
				}
			}
			.listt{
				margin-right: 101px;
			}
			.lists{
				margin-left: 100px;
			}
			
		}
		.child{
			.img{
				width: 45%;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.txt{
				width: 45%;
				
			}
		}
	}
</style>


// WEBPACK FOOTER //
// fwAnlis.vue?033bb41c